import { useState } from "react";
import { apiClient } from "@/context/AuthContext";
import { AlertTriangle, Loader2, Save, X } from "lucide-react";

export default function ActionEditModal({ finding, assessmentId, onClose, onToast, onSaved }) {
  const [actionText, setActionText] = useState(finding.action_text || "");
  const [question, setQuestion] = useState(finding.question || "");
  const [quantity, setQuantity] = useState(finding.quantity ?? "");
  const [unit, setUnit] = useState(finding.unit || "");
  const [actualQuantity, setActualQuantity] = useState(finding.actual_quantity ?? "");
  const [customNote, setCustomNote] = useState(finding.custom_note || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    setError(""); setLoading(true);
    try {
      await apiClient.patch(`/assessments/${assessmentId}/findings/${finding.id}`, {
        action_text: actionText, question, custom_note: customNote,
        quantity: quantity === "" ? null : Number(quantity),
        unit: unit || null,
      });
      // actual_quantity through verify endpoint
      if (actualQuantity !== "" && finding.resolved) {
        await apiClient.post(`/assessments/${assessmentId}/findings/${finding.id}/verify`,
          { action: "confirm", actual_quantity: Number(actualQuantity) });
      }
      onToast?.("Aksiyon güncellendi");
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err?.response?.data?.detail || "Kaydedilemedi");
    } finally { setLoading(false); }
  };

  const delta = (quantity !== "" && actualQuantity !== "")
    ? Number(actualQuantity) - Number(quantity) : null;

  return (
    <div className="modal-backdrop" data-testid="action-edit-modal">
      <div className="modal wide-modal">
        <div className="modal-head">
          <div><div className="eyebrow">AKSİYON DÜZENLE</div><h2>{finding.title}</h2></div>
          <button className="icon-button" onClick={onClose} data-testid="action-edit-close"><X size={17}/></button>
        </div>
        <div className="step-body">
          <label>Yapılması gereken (açıklama)
            <textarea rows={3} value={actionText} onChange={(e) => setActionText(e.target.value)} data-testid="action-text-input"/>
          </label>
          <label>Soru
            <input value={question} onChange={(e) => setQuestion(e.target.value)} data-testid="action-question-input"/>
          </label>
          <div className="row-fields">
            <label>Hesaplanan miktar
              <input type="number" step="0.01" value={quantity} onChange={(e) => setQuantity(e.target.value)} data-testid="action-quantity-input"/>
            </label>
            <label>Birim
              <input value={unit} onChange={(e) => setUnit(e.target.value)} data-testid="action-unit-input"/>
            </label>
            <label>Sahadaki mevcut miktar
              <input type="number" step="0.01" value={actualQuantity} onChange={(e) => setActualQuantity(e.target.value)} data-testid="action-actual-input"/>
            </label>
          </div>
          {delta !== null && (
            <div className={delta >= 0 ? "status-good" : "status-bad"} style={{padding:"8px 11px"}}>
              Fark: {delta >= 0 ? "+" : ""}{delta} {unit}
              {delta < 0 ? " (eksik)" : delta > 0 ? " (fazla)" : " (tam)"}
            </div>
          )}
          <label>Özel not (danışman)
            <textarea rows={2} value={customNote} onChange={(e) => setCustomNote(e.target.value)} data-testid="action-note-input" placeholder="Örn. 'Özel durum: zemin katta mutfak yangın söndürme sistemi var, otomatik kaplanıyor'"/>
          </label>
          {error && <div className="auth-error"><AlertTriangle size={14}/> {error}</div>}
          <div className="step-actions">
            <button type="button" className="secondary-btn" onClick={onClose}>İptal</button>
            <button type="button" className="primary-btn" onClick={save} disabled={loading} data-testid="action-save">
              {loading ? <Loader2 size={14} className="spin"/> : <Save size={14}/>} Kaydet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
